import { TextField } from "@mui/material";
import React from "react";

export const TimeTextField = (props: any) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;
    props.onTimeChange(props.id, inputValue);
  };

  const isValidTime = (timeValue: string) => {
    // Split the time value into components
    const [time, modifier] = timeValue.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    // Adjust hours based on the AM/PM modifier
    if (hours === 12) {
      hours = modifier === "AM" ? 0 : 12;
    } else if (modifier === "PM") {
      hours += 12;
    }

    // Define the allowed time range
    const startTime = 8; // 8 AM
    const endTime = 20; // 8 PM

    // Check if the selected time is outside the allowed range
    if (hours < startTime || hours > endTime) {
      // Update your state to show the error message
      return false;
    } else {
      // If time is valid, clear the error message and update the booking time
      return true;
    }
  };

  return (
    <>
      <TextField
        onChange={handleChange}
        onBlur={props.onBlur}
        id={`time-${props.id}`}
        variant="outlined"
        sx={{
          width: "150px", // Adjust width as needed
          "& input": {
            padding: "8px", // Adjust padding as needed
            fontSize: "14px", // Adjust font size as needed
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px", // Adjust border radius as needed
          },
        }}
        value={props.value}
        error={!isValidTime(props.value)} // Set error state based on validity
        helperText={
          !isValidTime(props.value)
            ? "Please select a time between 8 AM and 8 PM."
            : ""
        } // Show error message
      />
    </>
  );
};
